import React, { useState } from 'react'
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

function ViewSetting({ setting }) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>

            <OverlayTrigger
                key="top"
                placement="top"
                overlay={
                    <Tooltip id="tooltip-top">
                        View
                    </Tooltip>
                }
            >
                <img src="/images/png/view.png" onClick={handleShow} className="pointer" width={35} alt="action" />
            </OverlayTrigger>

            <Modal show={show} className='custom-modal' size='lg' centered scrollable onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>View Setting</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row g-3">
                        <div className="col-12 col-lg-6">
                            <Form.Label className='mb-0'>Item Key</Form.Label>
                            <p>{setting.title ? setting.title : "-"}</p>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Form.Label className='mb-0'>Created Date</Form.Label>
                            <p>{setting.createdAt ? new Date(setting.createdAt).toISOString().split("T")[0] : "-"}</p>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Form.Label className='mb-0'>Item Value</Form.Label>
                            <p className='mb-0 table-td-500 limit-lines' dangerouslySetInnerHTML={{ __html: setting.content ? setting.content : "" }} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ViewSetting